import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InitialModel, UserModel } from '../../../models/user.model';
import { AlertService } from '../../../services/alert.service';
import { UserService } from '../../../services/user.service';
import { translateUserType } from '../../../utils/language.utils';
import { getUserInitials } from '../../../utils/user.utils';

@Component({
  selector: 'app-lecturer-vita',
  templateUrl: './lecturer-vita.component.html',
  styleUrl: './lecturer-vita.component.scss',
  standalone: false,
})
export class LecturerVitaComponent {
  @Input() admin: boolean = false;
  @Input() lecturer: UserModel;
  @Output() editLecturer = new EventEmitter<void>();
  public isLoading = true;
  public user: UserModel;
  public userInitials: InitialModel;
  constructor(
    public userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private alertService: AlertService
  ) {}

  public getUserInitials = getUserInitials;
  public translateUserType = translateUserType;

  ngOnInit(): void {
    if (this.lecturer) {
      this.user = this.lecturer;
      this.userInitials = getUserInitials(this.lecturer);
      this.isLoading = false;
      return;
    }
    const userId = this.activatedRoute.snapshot.params['userId'];
    if (userId) {
      this.getUser(+atob(userId));
    }
  }

  private getUser(userId: number): void {
    this.userService.getLecturerDetails(userId).subscribe({
      next: user => {
        this.user = user;
        this.userInitials = getUserInitials(user);
        this.isLoading = false;
      },
      error: () => {
        this.alertService.showErrorAlert(
          'Die Vita des Dozenten konnte nicht geladen werden.'
        );
        this.location.back();
      },
    });
  }

  public onEdit(): void {
    if (this.admin) {
      this.editLecturer.emit();
      return;
    }
    this.router.navigate(
      ['/administration/contacts/edit', btoa(String(this.user.id))],
      {
        queryParams: { type: this.user.type },
      }
    );
  }

  public onBack(): void {
    this.location.back();
  }
}
